import ServiceBase from '../ServiceBase';

export default class QueueService extends ServiceBase {
    getQueueTaskStatus(queueTaskID) {
        return this.request('get', 'admin/queueTask/getQueueTaskStatus', {
            queueTaskID,
        });
    }
}
